'use client';

import { useEffect } from 'react';
import { Analytics } from '@/tracking/analytics';

export function NotFoundAnalytics({
  templateId,
  templateName,
}: {
  templateId: string;
  templateName: string;
}) {
  useEffect(() => {
    Analytics.notFound({ templateName, templateId }, { url: global.location?.href });
  }, [templateId, templateName]);
  return null;
}

export default NotFoundAnalytics;
